import { CondimentInterface } from "./Condiment";

export interface MixtureTabItemProps {
  name: string;
  image: string;
}

export interface MixtureState {
  name: string;
  nameHasError: boolean;
  condiments: CondimentInterface[] | [];
  totalParts: number;
  totalGrams: number;
  totalPercentage: number;
  selectedWeight: number;
  jars: number;
  nrJarsLimitPerMix: number;
  condimentLimitPerMix: number;
  mixtureOption: MixtureChooseEnum;
  mixtureIsLoading: boolean;
}

export interface MixtureListItemProps {
  condiment: CondimentInterface;
}

export interface ComputedPricesProps {
  condiments: CondimentInterface[];
  selectedWeight: number;
  markup: number;
  discount: number;
  vat: number;
  priceForPackaging: number;
  numberOfJars: number;
}

export interface PricesFromCondimentsInterface {
  totalCondimentPrice: number;
  totalCondimentPriceWithPackaging: number;
}

export const forbiddenCharacters = ['"', "'", "&", "<", ">"];

export enum MixtureChooseEnum {
  PARTS = "parts",
  GRAMS = "grams",
  PERCENTAGE = "percentage",
}

export const MixtureChooseOptions: MixtureChooseEnum[] = [
  MixtureChooseEnum.PARTS,
  MixtureChooseEnum.GRAMS,
  MixtureChooseEnum.PERCENTAGE,
];

export enum MixtureListProgressState {
  COMPLETED = "completed",
  NOT_COMPLETED = "not-completed",
  OVER_COMPLETED = "over-completed",
}
